export default __webpack_public_path__ + "static/media/polly-tab-logo-lockup.c9ead0b7.svg";